module.exports = __webpack_public_path__ + "img/cod.b57f9fb2.svg";